'use strict';

angular.module('mobile-apps').factory('GlossaryEntries', [
    '$resource',
    function ($resource) {
        return $resource(
            'v1/projects/:mobileAppId/glossary/entries',
            {
                mobileAppId: '@mobileAppId'
            },
            {
                get:
                {
                    method:'GET',
                    cache : false,
					isArray: true
                },
				create:
				{
					method: 'POST',
					cache: false,
					isArray: true
				},
				update:
				{
					method: 'PUT',
					cache: false,
					isArray: true
				},
				remove:
				{
					url : 'v1/projects/:mobileAppId/glossary/entries/delete',
					method:'POST',
					cache: false,
					isArray: true
				}
            }
        );
    }
]);
